import React, { useState, useEffect } from "react";
import GenericFormTabPo from "./GenericFormTabPo";
import { userDefinedItemFields } from "../formFields.js/PurchaseOrderFields";

const getCurrentDateTime = () => {
  const now = new Date();
  return now.toISOString().slice(0, 16);
};

export default function DetailUserDefinedTab({
  initialValues = {},
  onSubmit,
  onCancel,
  isAddButton,
  isEditMode,
  readOnly = false
}) {
  const [formData, setFormData] = useState({
    ...initialValues,
    createDate: initialValues.createDate || getCurrentDateTime(),
    editDate: initialValues.editDate || getCurrentDateTime(),
  });

  useEffect(() => {
    setFormData({
      ...initialValues,
      createDate: initialValues.createDate || getCurrentDateTime(),
      editDate: initialValues.editDate || getCurrentDateTime(),
    });
  }, [initialValues]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (readOnly) return;
    if (onSubmit) onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit}>
      <GenericFormTabPo fields={userDefinedItemFields} formData={formData} onChange={handleChange} readOnly={readOnly} />
      <div className="text-end mt-4 d-flex justify-content-end mt-5">
        <div className="ms-2">
          {!readOnly && <button type="submit" className="btn btn-primary px-5">
            {isEditMode ? "Update" : "Add1"}
          </button>}
        </div>
      </div>
    </form>
  );
}